export const getExchangeLogo = (exchange: string) => {
  switch (exchange) {
    case "OKX":
      return "/lovable-uploads/9374987f-70d0-4ef3-a74d-deada4d71a29.png";
    case "Bybit":
      return "/lovable-uploads/f8e24343-7970-4066-8449-f3d42e90e07e.png";
    case "Bitget":
      return "/lovable-uploads/c82b7495-c4d9-462e-90d9-bb62f24a1e7d.png";
    case "Phemex":
      return "/lovable-uploads/65150818-855b-40d2-b7f4-d5469fcee9b2.png";
    default:
      return "";
  }
};

export const getRiskLabel = (level: string) => {
  switch (level) {
    case "1":
      return "Low Risk";
    case "2":
      return "Medium Risk";
    case "3":
      return "High Risk";
    default:
      return "";
  }
};

export const getInvestmentLabel = (amount: string) => {
  switch (amount) {
    case "100":
      return "≤ 100 USDT";
    case "500":
      return "≤ 500 USDT";
    case "1000":
      return "≤ 1,000 USDT";
    case "2500":
      return "≤ 2,500 USDT";
    case "2501":
      return "≥ 2,501 USDT";
    default:
      return "All Amounts";
  }
};
